// impersonation.js — client side of staff acting as a candidate.
//
// The grant lives in sessionStorage so closing the tab ends the session. It is
// attached by wrapping window.fetch ONCE at start-up rather than by editing
// every fetch helper in the app: a new portal call cannot then forget to send
// it, which is the same reasoning as the server-side resolver middleware.
import API_BASE from './config';

const KEY = 'gt_impersonation';
const HEADER = 'x-gt-impersonate';

export function getImpersonation() {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const g = JSON.parse(raw);
    if (!g || !g.token) return null;
    // An expired grant is dead server-side anyway; clearing it here keeps the
    // banner honest rather than showing a session that no longer works.
    if (g.expires_at && new Date(g.expires_at).getTime() < Date.now()) {
      sessionStorage.removeItem(KEY);
      return null;
    }
    return g;
  } catch (e) {
    return null;
  }
}

export function clearImpersonation() {
  try { sessionStorage.removeItem(KEY); } catch (e) { /* nothing to clear */ }
}

let installed = false;
export function installImpersonationFetch() {
  if (installed) return;
  installed = true;
  const original = window.fetch.bind(window);
  window.fetch = function impersonatingFetch(input, init) {
    const grant = getImpersonation();
    if (!grant) return original(input, init);

    // ONLY our own API. Clerk refreshes its session token through window.fetch
    // too, and sending our header to Clerk both leaks it and breaks the call.
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const ours = url.indexOf('/api/') === 0
      || (API_BASE && url.indexOf(API_BASE + '/api/') === 0);
    if (!ours) return original(input, init);

    const next = { ...(init || {}) };
    const headers = new Headers((next && next.headers) || {});
    headers.set(HEADER, grant.token);
    next.headers = headers;
    return original(input, next);
  };
}
